import type { FilterData } from '@which/shared'

export const checkToFromValues = ({ filterData, externalId, to, from }: CheckToFromValuesArgs) => {
  const filterDataTo = filterData[externalId]?.['to']
  const filterDataFrom = filterData[externalId]?.['from']
  const toValue = String(to)
  const fromValue = String(from)

  if (filterDataTo && filterDataFrom) {
    return filterDataTo.includes(toValue) && filterDataFrom.includes(fromValue)
  }

  if (filterDataTo) {
    return filterDataTo.includes(toValue)
  }

  if (filterDataFrom) {
    return filterDataFrom.includes(fromValue)
  }

  return false
}

type CheckToFromValuesArgs = {
  filterData: FilterData
  externalId: string
  to?: number | null
  from?: number | null
}
